<template lang="pug">
  b-col
    b-row.mt-2.mb-2.align-items-baseline.justify-content-between.no-gutters
      b-col(cols="1")
        h3 Sucursales
      b-col.d-flex.justify-content-center.align-items-center.mb-3.p-0(v-if="hasSelectedLocations" cols="3" md="auto")
        transition.p-0.m-0(name="fade")
          .float-left.bg-secondary.text-center.text-white.p-3.rounded-lg
            p Seleccionados: {{ selected_locations.length }}
            .d-flex.justify-content-center.align-items-center
              .circle-button.mr-3.hover-primary.p-0(@click="toggleAllLocations")
                check-circle-icon.icon-md(v-b-tooltip.hover.bottom="'Seleccionar todas las sucursales'")
              .circle-button.hover-success.p-0(@click="locationsEditModal=true")
                edit-icon.icon-md(v-b-tooltip.hover.bottom="'Editar sucursales'")              
              //.circle-button.hover-success.ml-3(@click="personalizedSchedule=true")
                calendar-icon.icon-md(v-b-tooltip.hover.bottom="'Editar horarios de sucursales'")
      b-col.d-flex.justify-content-end.p-0(md="auto")
        b-form-group.d-flex.justify-content-end
          b-button.mr-1(v-if="canUpdateBranchOffice", variant="success", @click="location_modal = true", :disabled="!pickup_enabled") Añadir dirección
          b-button(v-if="canUpdateBranchOffice", variant="light", @click="settings_modal=true")
            v-icon.icon-md(name="cog")
    b-row(v-show="pickup_enabled")
      b-col.p-2.overflow-md-y.scrollable-area(cols="4", style="height: calc(90vh - 105px)")
        b-col.mb-2.p-0
          b-form-row.mb-2
            b-col(cols="auto")
              b-dropdown(size="sm", variant="light" no-caret dropdown  :menu-class="['filters-dropdown']")
                template(slot="button-content")
                  filter-icon.icon-sm
                  span.text-sm
                template(slot="default")
                  b-form-group
                    b-dropdown-form()
                      b-form-checkbox(v-model="filters.delivery_enable" :disabled="allLocations") Entregas a domicilio
                    b-dropdown-form()
                      b-form-checkbox(v-model="filters.pickup_enable" :disabled="allLocations") Retiro en tienda
                    b-dropdown-form()
                      b-form-checkbox(v-model="allLocations") Todas las sucursales
            b-col.pr-0
              b-form-group
                b-input-group(size="sm")
                  b-form-input(placeholder="Buscar..." size="sm" type="search" v-model="search_input" variant="outline-primary")
                  b-input-group-append.mr-2(rounded)
                    b-button(variant="outline-primary" size="sm")
                      search-icon.icon-sm
        .d-flex.align-items-start.p-2.location-row(v-for="(location, index) in locationsList" :key="index" style="border-radius:5px;")
          //- b-img.mr-3(:src="mapsURL + '&markers=color:0x1d91fe|label:L|' + location.latitude + ',' + location.longitude", v-if="location.map_image && !location.error", width="90", height="90", rounded)
          b-col
            b-form-checkbox(size="sm" @change="locationChecked(location)" :checked="selectedLocation(location)")
          .w-100.overflow-auto(@click="initPickup(location)")
            .d-flex.align-items-center.justify-content-between
              p.mb-0.text-truncate(v-if="location.name") {{ location.name }}
              p.mb-0.text-help.text-truncate(v-else) (Sin nombre)
              //div(@click.stop)
                b-checkbox(switch, size="sm" v-model="location.enable", @change="toggleEnable(location, $event)")
            p.mb-0.text-help.text-sm {{ location.full_address }}
        .d-flex.flex-column.align-items-center.p-2.justify-content-center.h-100(v-if="!locations.length")
          svg.bi.bi-signpost-split(xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewbox='0 0 16 16')
            path(d='M7 7V1.414a1 1 0 0 1 2 0V2h5a1 1 0 0 1 .8.4l.975 1.3a.5.5 0 0 1 0 .6L14.8 5.6a1 1 0 0 1-.8.4H9v10H7v-5H2a1 1 0 0 1-.8-.4L.225 9.3a.5.5 0 0 1 0-.6L1.2 7.4A1 1 0 0 1 2 7h5zm1 3V8H2l-.75 1L2 10h6zm0-5h6l.75-1L14 3H8v2z')
          h5.text-center.text-help.mt-3 No hay direcciones registradas.
          p.text-help.text-sm Agrega tu primera dirección
      b-col.overflow-md-y.scrollable-area(cols="8", style="max-height: calc(90vh - 105px)")
        b-col.align-items-start.w-100(v-show="place.latitude && place.longitude")
          b-tabs(justified, nav-class="flex-nowrap scrollable-area overflow-hidden overflow-x pb-1", small)
            b-tab(title="Sucursal", v-if="givePermissionInBranchOffice")
              b-col.d-flex.flex-column.justify-content-center.align-items-center.mb-3
                b-row.w-100(rounded="lg")
                  b-container.my-3#map-container(style="height:300px;width:100%;position:relative;", rounded="lg")
              b-col(v-if="place.latitude && place.longitude")
                b-form-group.w-100
                  b-form-textarea.w-100(readonly, :value="place.full_address", no-resize)
                b-form-row.mb-2
                  b-col
                    b-form-group(label="Entregas a domicilio", label-cols="auto", label-class="py-0" )
                      b-checkbox(switch, v-model="place.delivery_enable", @change="toggleEnable(place, 'delivery_enable', $event)", :disabled="!canUpdateBranchOffice && !$can('update', 'branch-office-switch')")
                  b-col
                    b-form-group(label="Entregas en tienda", label-cols="auto", label-class="py-0" )
                      b-checkbox(switch, v-model="place.pickup_enable", @change="toggleEnable(place, 'pickup_enable', $event)", :disabled="!canUpdateBranchOffice && !$can('update', 'branch-office-switch')")
                b-form-group(label="Nombre de punto de ubicación")
                  b-form-input(placeholder="Nombre de punto de ubicación", v-model="place.name", :state="place.name ? null : (place.validated ? false : null)", :disabled="!canUpdateBranchOffice")
                b-form-group(label="Descripción", description="Trata de que sea una descripción breve.")
                  b-form-textarea(placeholder="Descripción breve", v-model="place.description", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(label="Teléfono")
                  b-form-input(placeholder="Teléfono", v-model="place.cell_phone", :disabled="!canUpdateBranchOffice")
                b-form-group(label="Zonas de entrega" v-if="place.polygons.length > 0")
                  b-row.align-items-start.mb-2(v-for="(polygon,index) in (place.polygons)" :key="index")
                    b-col(cols="10")
                      b-form-input(:value="polygon.getPathStr()", :style="{'border-color': polygon.color,'border-width': '2px'}", :disabled="!canUpdateBranchOffice")
                    b-col(cols="1")
                      trash-icon.pointer(v-if="$can('update', 'branch-office')", @click="removePolygon(polygon.id)")
                b-form-group(label="Email de contacto")
                  b-form-input(placeholder="Email", v-model="place.email", :disabled="!canUpdateBranchOffice")
                b-form-group(label="Referencias", description="Información adicional que ayuden a localizar la ubicación")
                  b-form-textarea(placeholder="Referencias", v-model="place.reference", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(label="ID externo")
                  b-form-input(placeholder="ID externo", v-model="place.external_id", :disabled="!canUpdateBranchOffice")
                b-form-group(label="Horario de atención de la tienda")
                  b-form-textarea(v-model="place.disponibility_description", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(label="Horario de disponibilidad para envíos")
                  b-form-textarea(v-model="place.support_hours_delivery", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(label="Horario de disponibilidad para entrega")
                  b-form-textarea(v-model="place.support_hours_pickup", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(label="Tiempo de creacion para entrega")
                  b-form-textarea(v-model="place.time_creation_delivery", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(label="Tiempo máximo para entrega")
                  b-form-textarea(v-model="place.max_time_pickup", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(label="Tiempo estimado de entrega")
                  b-form-textarea(v-model="place.eta_delivery", no-resize, :disabled="!canUpdateBranchOffice")
                b-form-group(v-if="place.validate")
                  p.mb-0.text-danger.text-sm.text-center * Completa los campos marcados con rojo
                b-form-group.d-flex.mt-3.mb-3
                  b-button.mr-4(v-if="canUpdateBranchOffice", variant="success", @click="updateLocation($event)") Guardar
                  b-button(v-if="$can('delete', 'branch-office')", variant="danger", @click="deleteLocation(place.pickup_location_id)") Eliminar
                hr
                b-form-group.mb-3
                  span(v-b-toggle.clickMe) Derivar a otra sucursal
                  chevron-down-icon.ml-1.icon-md.collapse-chevron-icon(v-b-toggle.clickMe)
                  b-collapse.mt-3(id='clickMe')
                    b-card(class="cardToSlice")
                      k-select(placeholder="- Seleccionar sucursal -", :options="branchOffices", @input="changeBranchOffice", :value="place.derivated_location", :clearable="true")

            b-tab(title="Productos", v-if="givePermissionInProducts")
              b-col.d-flex.flex-column.justify-content-center.align-items-center.mb-1.mt-2
                b-input-group.w-100
                  b-form-input(placeholder="Buscar producto" v-model="product_search", @keyup.enter="searchProducts")
                  b-input-group-append
                    b-input-group-text(@click="searchProducts")
                      search-icon.icon-sm
              b-container.p-2.d-flex.justify-content-center.align-items-center.flex-column(md="auto")
                b-col.d-flex.justify-content-center.align-items-center.mb-2(cols="4", v-if="hasSelectedProducts")
                  transition(name="fade")
                    .selected-products-floating-widget.bg-secondary.text-center.text-white.p-3.rounded-lg
                      p Seleccionados {{ selected_products.length }}
                      .d-flex.justify-content-center.align-items-center.p-0.m-0
                        .circle-button.mr-3.hover-primary(@click="toggleAllProducts")
                          check-circle-icon.icon-md
                        .circle-button.mr-3.hover-success(@click="productsEditModal=true")
                          edit-icon.icon-md
                b-table.card-table.mb-0(:items="place_products", :fields="fields", responsive, @row-clicked="", hover, show-empty)
                  template(v-slot:empty)
                    p.mb-0.text-secondary No hay productos disponibles
                  template(v-slot:cell(name)="{ item }")
                    b-row.p-0.d-flex.align-items-start
                      b-form-checkbox(size="lg", @change="productChecked(item)", :checked="selectedProduct(item)", v-if="$can('update', 'product')")
                    b-container.d-flex.align-items-center
                      b-col.d-flex.justify-content-start.align-items-center.p-0(cols="auto")
                        b-img.mr-2(:src="item.image", v-if="item.image", width="40", height="40", rounded="circle")
                      b-col(cols="auto" md="auto")
                        h5.text-dark {{ item.name }}
                        p.mb-0.text-secondary.text-sm.text-justify {{ item.description }}
                  template(v-slot:cell(enabled)="{ item }")
                    div(v-if="$can('read', 'product')") {{(item.enabled) ? 'Activado' : 'Desactivado'}}
                    b-form-checkbox.ml-2.d-flex.justify-content-center.align-items-baseline(v-if="$can('update', 'product')", switch, @change="toggleProduct(item.id)", v-model="item.enabled")
              b-col.d-flex.justify-content-center.align-items-start.mt-1.overflow-auto
                b-pagination( v-model="current_page" :total-rows="place_products.length*total_pages" :per-page="place_products.length" @input="changePage")

            b-tab(title="Horarios")
              div.mt-3
                h4 {{place.name}}
              div   
                b-form-group.my-3
                  b-row
                    span.mx-3 Horarios de atención personalizados
                    b-checkbox(switch, v-model="place.supportHoursEnabled", @change="blockTable('supportHoursEnabled')")
                b-table.card-table.mb-0(:items="daysOfWeekSupport", :fields="personalizedSchedules", responsive, hover, show-empty, v-if="place.supportHoursEnabled")
                  template(v-slot:empty)
                    .text-secondary No hay datos para mostrar
                  template(v-slot:cell(from)="{ item }")
                    b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center
                      b-col(md="auto", v-if="item.from")
                        b-form-timepicker(v-model="item.from", placeholder="Hora", locale="es", :show-seconds="false", @hidden="updateHours(item, 'supportHours')")
                  template(v-slot:cell(to)="{ item }")
                    b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center                    
                      b-col(md="auto", v-if="item.to")
                        b-form-timepicker(v-model="item.to", placeholder="Hora", locale="es", @hidden="updateHours(item, 'supportHours')")
                  template(v-slot:cell(activated)="{ item }")
                    b-checkbox(switch, v-model="item.activated", @change="updateHours(item, 'supportHours')")
                div.mt-5   
                  b-form-group.my-3
                    b-row
                      span.mx-3 Horarios de entrega personalizados
                      b-checkbox(switch, v-model="place.deliveryHoursEnabled", @change="blockTable('deliveryHoursEnabled')")
                  b-table.card-table.mb-0(:items="daysOfWeekDelivery", :fields="personalizedSchedules", responsive, hover, show-empty, v-if="place.deliveryHoursEnabled")
                    template(v-slot:empty)
                      .text-secondary No hay datos para mostrar
                    template(v-slot:cell(from)="{ item }")
                      b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center
                        b-col(md="auto", v-if="item.from")
                          b-form-timepicker(v-model="item.from", placeholder="Hora", locale="es", :show-seconds="false", @hidden="updateHours(item, 'deliveryHours')")
                    template(v-slot:cell(to)="{ item }")
                      b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center                    
                        b-col(md="auto", v-if="item.to")
                          b-form-timepicker(v-model="item.to", placeholder="Hora", locale="es", @hidden="updateHours(item, 'deliveryHours')")
                    template(v-slot:cell(activated)="{ item }")
                      b-checkbox(switch, v-model="item.activated", @change="updateHours(item, 'deliveryHours')")           
                div.mt-5 
                  b-form-group.my-3
                    b-row
                      span.mx-3 Horarios de recolección personalizados
                      b-checkbox(switch, v-model="place.pickupHoursEnabled", @change="blockTable('pickupHoursEnabled')")
                  b-table.card-table.mb-0(:items="daysOfWeekPickup", :fields="personalizedSchedules", responsive, hover, show-empty, v-if="place.pickupHoursEnabled")
                    template(v-slot:empty)
                      .text-secondary No hay datos para mostrar
                    template(v-slot:cell(from)="{ item }")
                      b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center
                        b-col(md="auto", v-if="item.from")
                          b-form-timepicker(v-model="item.from", placeholder="Hora", locale="es", :show-seconds="false", @hidden="updateHours(item, 'pickupHours')")
                    template(v-slot:cell(to)="{ item }")
                      b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center                    
                        b-col(md="auto", v-if="item.to")
                          b-form-timepicker(v-model="item.to", placeholder="Hora", locale="es", @hidden="updateHours(item, 'pickupHours')")
                    template(v-slot:cell(activated)="{ item }")
                      b-checkbox(switch, v-model="item.activated", @change="updateHours(item, 'pickupHours')")                                   
                                    

        b-col.d-flex.flex-column.justify-content-center.align-items-center.h-100(v-if="!place.latitude || !place.longitude")
          svg.bi.bi-geo-alt-fill(xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewbox='0 0 16 16')
            path(d='M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z')
          h5.text-center.text-help.mt-3 Selecciona una ubicación.
    b-row(v-show="!pickup_enabled" style="height:calc(90vh - 105px)")
      b-col.d-flex.flex-column.justify-content-center.align-items-center.h-100.w-100(style="max-height: calc(90vh - 105px)")
        svg.bi.bi-truck(xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewbox='0 0 16 16')
          path(d='M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z')
        h5.text-center.text-help.mt-3 Activa los puntos de entrega.
    b-modal(title="Editar sucursales" v-model="locationsEditModal" ok-title="Actualizar" @ok="locationsEditMany" cancel-title="Cancelar")
      b-container.overflow-md-y.scrollable-area(style="max-height: calc(80vh - 105px)")
        b-row.d-flex.justify-content-center.align-items-baseline
          b-form-group.mr-2(label="Entregas a domicilio" label-cols="auto", label-class="py-0")
            b-form-checkbox(v-model="locationsEdit.delivery_enable", switch)
          b-form-group(label="Entregas en tienda" label-cols="auto", label-class="py-0")
            b-form-checkbox(v-model="locationsEdit.pickup_enable", switch)
        b-form-group(label="Horario de atención de la tienda")
          b-form-textarea(v-model="locationsEdit.disponibility_description", no-resize)
        b-form-group(label="Horario de disponibilidad para envíos")
          b-form-textarea(v-model="locationsEdit.support_hours_delivery", no-resize)
        b-form-group(label="Horario de disponibilidad para entrega")
          b-form-textarea(v-model="locationsEdit.support_hours_pickup", no-resize)
        b-form-group(label="Tiempo de creacion para entrega")
          b-form-textarea(v-model="locationsEdit.time_creation_delivery", no-resize)
        b-form-group(label="Tiempo máximo para entrega")
          b-form-textarea(v-model="locationsEdit.max_time_pickup", no-resize)
        b-form-group(label="Tiempo estimado de entrega")
          b-form-textarea(v-model="locationsEdit.eta_delivery", no-resize)

    b-modal(title="Ajustes" v-model="settings_modal")
      b-form-group
        b-col
          b-row
            b-col.p-0(cols="auto")
              h5.mb-2 Puntos de entrega
            b-col(cols="auto")
              b-form-checkbox(switch, v-model="pickup_enabled", @change="updateEcommerceData('pickup', $event)")
                span.text-sm {{ pickup_enabled ? 'Activado' : 'Apagado'}}
        p.text-help.text-sm Puedes activar o desactivar los puntos de entrega en el sitio.
      b-form-group
        b-col
          b-row
            b-col.p-0(cols="auto")
              h5.mb-2 Envios a costo fijo
            b-col(cols="auto")
              b-form-checkbox(switch, v-model="delivery_enabled", @change="updateEcommerceData('delivery', $event)", size="md", v-if="!isKanguroEnabled")
                span.text-sm {{ delivery_enabled ? 'Activado' : 'Apagado'}}
              span.text-danger(v-else) Envíos Kanguro está habilitado
        p.text-help.text-sm.m-0.p-0 Puedes activar o desactivar los envíos a costo fijo en el sitio.
        p.text-help.text-sm.m-0.p-0 La logistica corre por tu cuenta.
        b-row(v-if="delivery_enabled")
          b-col(v-if="!isKanguroEnabled")
            b-alert.text-sm.mb-3(:show="deliveryPriceMissing && delivery_enabled && !isKanguroEnabled", variant="danger") Debes introducir un costo de envío o tu Chatbot puede presentar errores. Puede ser cero si no cobras por envíos.
            b-form-group(label="Costo por envío")
              b-col
                b-input-group
                  b-input-group-prepend
                    b-input-group-text
                      dollar-sign-icon.icon-sm
                  b-form-input(type="number", v-model="delivery_price", @input="price_edited = true", :state="deliveryPriceMissing && delivery_enabled ? false : null", :disabled="!delivery_enabled", @change="updateDeliveryBasic")
    b-modal(v-model="location_modal", title="Crear punto surcursal", ok-title="Crear", cancel-title="Cancelar", ok-variant="success", hide-footer, @ok="createLocation($event)", static, no-close-on-backdrop size="lg" @close="resetCreateLocation")
      h6.text-bold 1. Busca la dirección de sucursal
      b-form-group(label="Buscar dirección:", description="Selecciona la opción correcta del autocompletado. Powered by Google.")
        b-input-group
          b-form-input(placeholder="Escribe la dirección a buscar...", v-model="address_search", id="search_autocomplete", autocomplete="on", @focus="$event.target.select()", :state="address_search ? null : (new_place.validated ? false : null)")
          b-input-group-append
            b-input-group-text
              map-pin-icon.icon-sm
      b-alert.text-sm(:show="showDragMapAlert", variant="info") Puedes arrastra el mapa para precisar la ubicación.
      div#pikcupMap.my-3(style="height:300px;width:100%;position:relative;")
      div(v-if="new_place.pickup_location_id")
        validation-observer(v-slot="{ invalid, dirty, handleSubmit, errors }")
          form(@submit.prevent="handleSubmit(createLocation)")
            h6.text-bold 2. Verifica que la dirección sea correcta
            b-form-row
              b-col.mb-3(cols="12")
                validation-provider(rules="required" name="calle" v-slot="{ valid, errors }")
                  b-form-group(label="Calle")
                    b-form-input(v-model="new_place.street" :state="valid ? null : false")
                    b-form-invalid-feedback {{errors[0]}}
              b-col.mb-3(cols="6")
                validation-provider(name="no. exterior" v-slot="{ valid, errors }")
                  b-form-group(label="No. exterior")
                    b-form-input(v-model="new_place.street_number" :state="valid ? null : false")
                    b-form-invalid-feedback {{errors[0]}}
              b-col.mb-3(cols="6")
                b-form-group(label="No. interior")
                  b-form-input(v-model="new_place.interior_number")
              b-col.mb-3(cols="6")
                validation-provider(rules="required|digits:5" name="código postal" v-slot="{ valid, errors }")
                  b-form-group(label="Código Postal")
                    b-form-input(v-model="new_place.zip" :state="valid ? null : false")
                    b-form-invalid-feedback {{errors[0]}}
              b-col.mb-3(cols="6")
                validation-provider(rules="required" name="colonia" v-slot="{ valid, errors }")
                  b-form-group(label="Colonia/Distrito")
                    b-form-input(v-model="new_place.colony" :state="valid ? null : false")
                    b-form-invalid-feedback {{errors[0]}}
              b-col.mb-3(cols="6" v-if="new_place.country==='MX'")
                validation-provider(rules="required" name="municipio" v-slot="{ valid, errors }")
                  b-form-group(label="Municipio")
                    b-input-group
                      b-form-input(v-model="new_place.municipality" :state="valid ? null : false")
                      template(#append, v-if='loadingColony')
                        b-input-group-text
                          b-spinner(small, variant="primary")
                    b-form-invalid-feedback {{errors[0]}}
              b-col.mb-3(cols="6")
                validation-provider(rules="required" name="ciudad" v-slot="{ valid, errors }")
                  b-form-group(label="Ciudad/Provincia")
                    b-form-input(v-model="new_place.city" :state="valid ? null : false")
                    b-form-invalid-feedback {{errors[0]}}
              b-col.mb-3(cols="6" v-if="new_place.country==='MX'")
                validation-provider(rules="required" name="estado" v-slot="{ valid, errors }")
                  b-form-group(label="Estado")
                    b-form-input(v-model="new_place.state" :state="valid ? null : false")
                    b-form-invalid-feedback {{errors[0]}}

            h6.text-bold 3. Da un nombre y descripción al punto de la surcursal e indica la disponibilidad de horario del lugar.
            validation-provider(rules="required" :name="'nombre de punto de ' + (newKanguroLocation ? 'recolección' : 'entrega')" v-slot="{ valid, errors }")
              b-form-group(label="Nombre de ubicación")
                b-form-input(placeholder="Nombre de punto de ubicación", v-model="new_place.name", :state="valid ? null : false")
                b-form-invalid-feedback {{errors[0]}}

            b-form-group(label="Descripción", description="Trata de que sea una descripción breve.")
              b-form-textarea(placeholder="Descripción breve", v-model="new_place.description", no-resize, rows="2", max-rows="5")
            validation-provider(rules="digits:10" name="teléfono" v-slot="{ valid, errors }")
              b-form-group(label="Teléfono")
                b-form-input(placeholder="Teléfono", v-model="new_place.cell_phone", :state="valid ? null : false")
                b-form-invalid-feedback {{errors[0]}}

            validation-provider(rules="email" name="email" v-slot="{ valid, errors }")
              b-form-group(label="Email de contacto")
                b-form-input(placeholder="Email", v-model="new_place.email" :state="valid ? null : false")
                b-form-invalid-feedback {{errors[0]}}

            b-form-group(label="Referencias", description="Información adicional que ayuden a localizar la ubicación")
              b-form-textarea(placeholder="Referencias", v-model="new_place.reference", no-resize, rows="2", max-rows="5")
            b-form-group(label="Describe la disponibilidad en días y horarios")
              b-form-textarea(v-model="new_place.disponibility_description", no-resize, rows="2", max-rows="5")

            b-form-group.mt-3(v-if="invalid && dirty")
              p.mb-0.text-danger.text-sm.text-center * Completa los campos marcados con rojo

            .mt-3.w-75.mx-auto
              b-button.px-4(variant="success" :disabled="invalid" type="submit" block) Crear

    b-modal(titel="Editar productos" v-model="productsEditModal" @ok="productsEditMany")
      b-container.overflow-md-y.scrollable-area(style="max-height: calc(80vh - 105px)")
          b-row.d-flex.justify-content-start.mb-2
            b-form-group(label="Disponible" label-cols="auto", label-class="py-0")
              b-form-checkbox(v-model="productsEdit.enabled", switch)
          b-row.d-flex.justify-content-between.mb-2
            b-form-group(label="Precio")
              b-form-input(v-model="productsEdit.price" type="number" min="0" step="0.1" size="sm")
            b-form-group(label="Stock")
              b-form-input(v-model="productsEdit.stock" type="number" min="0" size="sm")

    b-modal(title="Editar horario de sucursales", v-model="personalizedSchedule", size="lg", ok-title="Actualizar", cancel-title="Cancel", @ok="updateHoursOfSelectedBranchOffices")
      b-table.card-table.mb-0(:items="daysOfWeekSupport", :fields="personalizedSchedules", responsive, hover, show-empty)
        template(v-slot:empty)
          .text-secondary No hay datos para mostrar
        template(v-slot:cell(from)="{ item }")
          b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center
            b-col(md="auto", v-if="item.from")
              b-form-timepicker(v-model="daysOfWeekSupport['from'] = item.from", placeholder="Hora", locale="es", :show-seconds="false")
        template(v-slot:cell(to)="{ item }")
          b-form-row.mb-0.row-cols-1.row-cols-md-3.align-items-center                    
            b-col(md="auto", v-if="item.to")
              b-form-timepicker(v-model="daysOfWeekSupport['to'] = item.to", placeholder="Hora", locale="es")
        template(v-slot:cell(activated)="{ item }")
          b-checkbox(switch, v-model="daysOfWeekSupport['activated'] = item.activated")
  </template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { EventBus } from '@/helpers/eventBus'
import { Polygon } from '@/helpers/mapHelper'
import { Product } from '@/helpers/pickupProducts'
import Select from '../../components/Select'

const accountController = createNamespacedHelpers('account')
const deliveryController = createNamespacedHelpers('delivery')
const locationController = createNamespacedHelpers('location')

window.initPlaces = function () {
  EventBus.$emit('places_loaded')
}

const addValue = function (key, value) {
  const { params } = this
  if (!value || isNaN(value)) return
  params[key] = value
  return params
}

export default {
  data() {
    return {
      mapPolygons:{},
      allLocations: true,
      filters: {
        delivery_enable: false,
        pickup_enable: false
      },
      search_input: '',
      productsEditModal: false,
      selected_products: [],
      selected_locations: [],
      place_products: [],
      settings_modal: false,
      address_search: '',
      location_modal: false,
      delivery_enabled: false,
      pickup_enabled: false,
      delivery_price: null,
      price_edited: false,
      isTableHidden: false,
      personalizedSchedules: [
        { key: 'day', label: 'Día' },        
        { key: 'from', label: 'Apertura' },
        { key: 'to', label: 'Cierre' },
        { key: 'activated', label: 'Activado' },
      ],
      daysOfWeekSupport: [
        { dayKey: "monday", day:'Lunes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "tuesday", day:'Martes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "wednesday", day:'Miércoles', from: "14:00", to: "19:00", activated: true },
        { dayKey: "thursday", day:'Jueves', from: "14:00", to: "19:00", activated: true },
        { dayKey: "friday", day:'Viernes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "saturday", day:'Sábado', from: "14:00", to: "19:00", activated: true },
        { dayKey: "sunday", day:'Domingo', from: "14:00", to: "19:00", activated: true },
      ],
      daysOfWeekDelivery: [
        { dayKey: "monday", day:'Lunes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "tuesday", day:'Martes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "wednesday", day:'Miércoles', from: "14:00", to: "19:00", activated: true },
        { dayKey: "thursday", day:'Jueves', from: "14:00", to: "19:00", activated: true },
        { dayKey: "friday", day:'Viernes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "saturday", day:'Sábado', from: "14:00", to: "19:00", activated: true },
        { dayKey: "sunday", day:'Domingo', from: "14:00", to: "19:00", activated: true },
      ],
      daysOfWeekPickup: [
        { dayKey: "monday", day:'Lunes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "tuesday", day:'Martes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "wednesday", day:'Miércoles', from: "14:00", to: "19:00", activated: true },
        { dayKey: "thursday", day:'Jueves', from: "14:00", to: "19:00", activated: true },
        { dayKey: "friday", day:'Viernes', from: "14:00", to: "19:00", activated: true },
        { dayKey: "saturday", day:'Sábado', from: "14:00", to: "19:00", activated: true },
        { dayKey: "sunday", day:'Domingo', from: "14:00", to: "19:00", activated: true },
      ],            
      place_fields: {
        street_number: 'short_name',
        route: 'long_name',
        sublocality_level_1: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
      },
      new_place_copy: {},
      new_place: {
        full_address: '',
        pickup_location_id: '',
        map_image: '',
        latitude: '',
        longitude: '',
        name: '',
        description: '',
        disponibility_description: '',
        enable: true,
        home_phone: '',
        cell_phone: '',
        email: '',
        reference: '',
        street: '',
        street_number: '',
        interior_number: '',
        colony: '',
        city: '',
        state: '',
        zip: '',
        municipality: '',
        validated: false,
        support_hours_delivery: '',
        support_hours_pickup: '',
        time_creation_delivery: '',
        max_time_pickup: '',
        eta_delivery: ''        
      },
      availability_days: [
        {
          text: 'Lunes',
          value: 'Lunes'
        },
        {
          text: 'Martes',
          value: 'Martes'
        },
        {
          text: 'Miércoles',
          value: 'Miércoles'
        },
        {
          text: 'Jueves',
          value: 'Jueves'
        },
        {
          text: 'Viernes',
          value: 'Viernes'
        },
        {
          text: 'Sábado',
          value: 'Sábado'
        },
        {
          text: 'Domingo',
          value: 'Domingo'
        }
      ],
      availability_days_picked: [],
      time_from: {
        hh: '12',
        mm: '00',
        A: 'AM'
      },
      time_to: {
        hh: '11',
        mm: '59',
        A: 'PM'
      },
      mapsURL:
          'https://maps.googleapis.com/maps/api/staticmap?&size=160x160&maptype=roadmap&region=mx&language=es&key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo',
      mapsURLBig:
          'https://maps.googleapis.com/maps/api/staticmap?&size=500x281&maptype=roadmap&region=mx&language=es&key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo',
      place: {
        derivated_location: null,
        street_number: '',
        postal_code: '',
        full_address: '',
        pickup_location_id: '',
        map_image: '',
        latitude: '',
        longitude: '',
        name: '',
        description: '',
        disponibility_description: '',
        enable: true,
        home_phone: '',
        cell_phone: '',
        email: '',
        reference: '',
        validated: false,
        interior_number: '',
        municipality: '',
        polygons: [],
        support_hours_delivery: '',
        support_hours_pickup: '',
        time_creation_delivery: '',
        max_time_pickup: '',
        eta_delivery: '',
        delivery_enable: false,
        pickup_enable: true,
        external_id: '',
        supportHoursEnabled: false,
        deliveryHoursEnabled: false,
        pickupHoursEnabled: false,
        supportHours: {
          monday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          tuesday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          wednesday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          thursday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          friday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          saturday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          sunday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          }
        },
        deliveryHours: {
          monday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          tuesday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          wednesday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          thursday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          friday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          saturday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          sunday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          }
        },
        pickupHours: {
          monday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          tuesday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          wednesday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          thursday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          friday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          saturday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          },
          sunday: {
            enabled: true,
            from: "00:00:00",
            to: "00:00:00"
          }
        }        
      },
      edit_location_modal: false,
      loadingColony: false,
      map: null,
      showDragMapAlert: false,
      shippingCollapse: false,
      pickupCollapse: false,
      newKanguroLocation: false,
      kanguro_pickup_location_created: null,
      kanguro_enabled_temp: false,
      pickupMap: null,
      drawingManager: null,
      colors: [],
      polygons: [],
      search_product: '',
      total_pages: 1,
      current_page: 1,
      product_search: '',
      fields: [
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'price',
          label: 'Precio'
        },
        {
          key: 'stock',
          label: 'Stock'
        },
        {
          key: 'enabled',
          label: 'Estado'
        }
      ],
      locationsEditModal: false,
      personalizedSchedule: false,
      locationsEdit: {
        delivery_enable: false,
        pickup_enable: false,
        disponibility_description: '',
        support_hours_delivery: '',
        support_hours_pickup: '',
        time_creation_delivery: '',
        max_time_pickup: '',
        eta_delivery: ''
      },
      productsEdit: {
        enabled: false,
        price: null,
        stock: null
      },
      locationsList: [],
      branchOffices: []
    }
  },
  computed: {
    ...accountController.mapState({
      account: (state) => state.account
    }),
    ...locationController.mapState({
      locations: (state) =>
        state.pickup_locations.map((pickupLocation) => {
          const { Shapes = [] } = pickupLocation
          return {
            ...pickupLocation,
            id: pickupLocation.pickup_location_id,
            label: pickupLocation.name,
            polygons: Shapes.map(
              ({ Points = [], color, shape_id: shapeId }) => {
                const polygon = new Polygon(
                  Points.map((point) => {
                    return [Number(point.latitude), Number(point.longitude)]
                  }),
                  shapeId
                )
                if (color) polygon.color = color
                return polygon
              }
            )
          }
        })
    }),
    ...deliveryController.mapState({
      delivery_types: (state) => state.delivery_types,
      ecommerce_data: (state) => state.ecommerce_data
    }),
    basicDelivery() {
      return this.delivery_types.find((d) => d.name === 'Basic')
    },
    kanguroDelivery() {
      return this.delivery_types.find((d) => d.name === 'Kanguro')
    },
    isKanguroEnabled() {
      if (!this.delivery_types.length) return false
      const deliveryType = this.ecommerce_data.Delivery_Type
      const enabled =
          Boolean(deliveryType) &&
          deliveryType.delivery_type_id === this.kanguroDelivery.delivery_type_id
      return enabled
    },
    weekDays() {
      return this.availability_days.slice(0, 5).map((d) => d.text)
    },
    areTimesPicked() {
      let missingData = false

      for (const key in this.time_from) {
        if (!this.time_from[key]) missingData = true
      }

      for (const key in this.time_to) {
        if (!this.time_to[key]) missingData = true
      }

      return !missingData
    },
    deliveryPriceMissing() {
      return this.delivery_price === undefined || this.delivery_price === ''
    },
    pickupLocations() {
      const locations = this.locations.filter((location) => {
        const {
          kanguro_account_uuid: kanguroId,
          pickup_location_id: pickupLocId
        } = location
        const { kanguro_pickup_location_created: kanguroCreated } = this
        const isValidLocation = Object.values(location).every((value) => !value)
        return [
          !kanguroId,
          pickupLocId !== kanguroCreated,
          !isValidLocation
        ].every(Boolean)
      })
      return locations
    },
    hasSelectedProducts() {
      return Boolean(this.selected_products.length)
    },
    hasSelectedLocations() {
      return Boolean(this.selected_locations.length)
    },
    givePermissionInProducts() {
      return this.$can('read', 'product') || this.$can('update', 'product')
    },
    givePermissionInBranchOffice() {
      return this.$can('read', 'branch-office') || this.$can('update', 'branch-office')
    },
    canUpdateBranchOffice() {
      return this.$can('update', 'branch-office')
    }
  },
  methods: {
    ...mapActions([
      'location/all',
      'location/get',
      'location/getSchedule',
      'location/create',
      'location/update',
      'location/updateSchedule',
      'location/destroy',
      'delivery/all',
      'delivery/associateEcommerce',
      'delivery/updateDeliveryBasic',
      'delivery/ecommerce',
      'delivery/updateEcommerce',
      'helpers/zip_code',
      'kanguro/add_address',
      'location/createPolygon',
      'location/deletePolygon',
      'location/products',
      'location/toggleProduct',
      'location/editManyProducts',
      'location/editManyLocations'
    ]),
    getLocationSchedule(pickupLocationId) {
      const self = this

      this['location/getSchedule']({
        pickup_location_id: pickupLocationId,
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
            return 
          }         
            this.place.supportHoursEnabled = res.resource.supportHoursEnabled;
            this.place.deliveryHoursEnabled = res.resource.deliveryHoursEnabled;
            this.place.pickupHoursEnabled = res.resource.pickupHoursEnabled;
            this.place.supportHours = res.resource.supportHours;
            this.place.deliveryHours = res.resource.deliveryHours;
            this.place.pickupHours = res.resource.pickupHours;

            this.daysOfWeekSupport = this.daysOfWeekSupport.map(item => {
              return {
                  dayKey: item.dayKey,
                  day: item.day,
                  activated: this.place.supportHours[item.dayKey].enabled,
                  from: this.place.supportHours[item.dayKey].from,
                  to: this.place.supportHours[item.dayKey].to
              }     
            })
            this.daysOfWeekDelivery = this.daysOfWeekDelivery.map(item => {
              return {
                  dayKey: item.dayKey,
                  day: item.day,
                  activated: this.place.deliveryHours[item.dayKey].enabled,
                  from: this.place.deliveryHours[item.dayKey].from,
                  to: this.place.deliveryHours[item.dayKey].to
              }     
            })
            this.daysOfWeekPickup = this.daysOfWeekPickup.map(item => {
              return {
                  dayKey: item.dayKey,
                  day: item.day,
                  activated: this.place.pickupHours[item.dayKey].enabled,
                  from: this.place.pickupHours[item.dayKey].from,
                  to: this.place.pickupHours[item.dayKey].to
              }     
            })
            
        }
      })
    },
    buildBranchOfficesToDerivate() {
      this.branchOffices = this.locations.map((location) => { return location })
      this.branchOffices.unshift({ id: '', label: 'No derivar' })
    },
    updateHours(item, type) {    
      let pickupLocationId = this.place.pickup_location_id;
      this.place[type][item.dayKey] = {
        enabled: item.activated,
        from: item.from,
        to: item.to
      }
      this['location/updateSchedule']({
        pickup_location_id: pickupLocationId,
        [type]: this.place[type],
        callback: async (res) => {
          if (res.error) return this.$message.error(res.error)          
          this.$message.success('Horario actualizado')          
        }
      })
    },
    updateHoursOfSelectedBranchOffices() {
      let { selected_locations: selectedLocations } = this
      let dayOfWeekToUpdate = null

      selectedLocations.forEach((location) => {
        this.daysOfWeekSupport = this.daysOfWeekSuppor.map(item => {
 
          dayOfWeekToUpdate = {
            dayKey: item.dayKey,
            day: item.day,
            activated: item.activated,
            from: item.from,
            to: item.to
          }

          this.updateHours(dayOfWeekToUpdate, location.pickup_location_id)

          return dayOfWeekToUpdate
        })

        return this.daysOfWeekSupport
      })
    },
    blockTable(type) {
      this['location/updateSchedule']({
        [type]: this.place[type],
        pickup_location_id: this.place.pickup_location_id,
        callback: async (res) => {
          if (res.error) return this.$message.error(res.error)

          if (this.place[type] == true) {
            return this.$message.success('Horario mostrado')
          } else {
            return this.$message.success('Horario ocultado')
          }
        }
      })

    },
    changeBranchOffice(branchOfficeId) {
      if (this.place.derivated_location == branchOfficeId) return

      this.place.derivated_location = branchOfficeId || null

      this['location/update']({
        ...this.place,
        callback: async (res) => {
          if (res.error) { 
            return this.$message.warning('Error al derivar sucursal')
          }

          return this.$message.success('Se ha derivado exitosamente')
        }
      })
    },
    searchFilter(text) {
      return this.locations.filter((location) => {
        const { name, description, full_address: fullAddress } = location
        const search = text.toLowerCase()
        const nameMatch = name.toLowerCase().includes(search)
        const descriptionMatch = description.toLowerCase().includes(search)
        const addressMatch = fullAddress.toLowerCase().includes(search)
        return [nameMatch, descriptionMatch, addressMatch].some(Boolean)
      })
    },
    matchFilters(locations) {
      const { filters, search_input: searchInput, allLocations } = this
      const filtersKeys = Object.keys(filters)
      const isEmptyFilters = filtersKeys.every((key) => !filters[key])
      const filterMethod = isEmptyFilters ? 'every' : 'some'
      if (searchInput) locations = this.searchFilter(searchInput)
      if (allLocations) {
        this.locationsList = locations
        return
      }
      this.locationsList = locations.filter((location) => {
        return filtersKeys[filterMethod]((prop) => {
          const filterPropState = filters[prop]
          const locationProp = location[prop]
          const activeFilter =
              locationProp === filterPropState && filterPropState
          const noFilter = locationProp === filterPropState && !filterPropState
          return isEmptyFilters ? noFilter : activeFilter
        })
      })
    },
    selectedProduct(product) {
      const productIndex = this.selected_products.findIndex(
        (p) => p.stockId === product.stockId
      )
      if (productIndex === -1) return false
      product.checked = true
      return true
    },
    selectedLocation(location) {
      const locationIndex = this.selected_locations.findIndex(
        (l) => l.pickup_location_id === location.pickup_location_id
      )
      if (locationIndex === -1) return false

      return true
    },
    toggleAllProducts() {
      const {
        selected_products: selectedProducts,
        place_products: placeProducts
      } = this
      const sameLength = selectedProducts.length === placeProducts.length
      this.selected_products = sameLength ? [] : placeProducts
      this.place_products.forEach((product) => {
        product.checked = !sameLength
      })
    },
    toggleAllLocations() {
      const { selected_locations: selectedLocations, locations } = this
      const sameLength = selectedLocations.length === locations.length
      this.selected_locations = sameLength ? [] : locations

      this.locations.forEach((location) => {
        location.checked = !sameLength
      })
    },
    productChecked(product) {
      const { stockId, checked = false } = product
      product.checked = !checked
      const { selected_products: selectedProducts } = this
      const index = selectedProducts.findIndex((p) => p.stockId === stockId)
      if (index === -1) return this.selected_products.push(product)
      this.selected_products.splice(index, 1)
    },
    locationChecked(location) {
      const { pickup_location_id: pickupLocationId, checked = false } = location
      location.checked = !checked
      const { selected_locations: selectedLocations } = this
      const index = selectedLocations.findIndex(
        (l) => l.pickup_location_id === pickupLocationId
      )
      if (index === -1) return this.selected_locations.push(location)
      this.selected_locations.splice(index, 1)
    },
    productsEditMany() {
      const { productsEdit } = this
      const { enabled, price, stock } = productsEdit
      const products = this.selected_products.map(({ stockId }) => stockId)
      const data = {
        enabled
      }
      const paramDecorator = addValue.bind({ params: data })
      paramDecorator('price', price)
      paramDecorator('stock', stock)
      this['location/editManyProducts']({
        params: {
          products,
          data
        },
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)
          this.$message.success('Productos actualizados')
          this.selected_products.forEach((product) => {
            Object.keys(data).forEach((key) => {
              product[key] = data[key]
            })
            product.checked = false
          })
          this.selected_products = []
          this.productsEdit = {
            enabled: false,
            price: null,
            stock: null
          }
          this.productsEditModal = false
        }
      })
    },
    locationsEditMany() {
      const { selected_locations: selectedLocations, locationsEdit } = this
      const locations = selectedLocations.map(
        ({ pickup_location_id: pickupLocationId }) => pickupLocationId
      )
      const data = Object.keys(locationsEdit).reduce((acc, key) => {
        if (locationsEdit[key] !== '') acc[key] = locationsEdit[key]
        return acc
      }, {})
      this['location/editManyLocations']({
        params: {
          locations,
          data
        },
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)
          this.$message.success('Ubicaciones actualizadas')
          const locationsUpdated = this.locationsList.map((location) => {
            if (!locations.includes(location.pickup_location_id)) return location
            Object.keys(data).forEach((key) => {
              // assign new values to locations list
              location[key] = data[key]
            })
            return location
          })
          this.matchFilters(locationsUpdated)
          this.selected_locations = []
          this.locationsEdit = {
            delivery_enable: false,
            pickup_enable: false,
            disponibility_description: '',
            support_hours_delivery: '',
            support_hours_pickup: '',
            time_creation_delivery: '',
            max_time_pickup: '',
            eta_delivery: ''
          }
        }
      })
    },
    getLocations() {
      const self = this
      // this.showLoadingScreen()

      this['location/all']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          self.hideLoadingScreen()
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    getMunicipality() {
      const self = this
      this.loadingColony = true

      this['helpers/zip_code']({
        zipcode: self.new_place.zip,
        callback: (res) => {
          this.loadingColony = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            const locations = res.resource.map((el) => {
              return {
                colony: el.d_asenta,
                municipality: el.D_mnpio,
                state: el.d_estado,
                city: el.d_ciudad
              }
            })

            if (locations.length) {
              this.new_place.municipality = locations[0].municipality
            }
          }
        }
      })
    },
    getLocation(pickupLocationId) {
      const self = this

      this['location/get']({
        pickup_location_id: pickupLocationId,
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            const index = this.locations.findIndex(
              (l) => l.pickup_location_id === pickupLocationId
            )
            if (index >= 0) {
              this.locations.splice(index, 1, res.resource)
            }
          }
        }
      })
    },
    createLocation() {
      const self = this
      const newPlace = JSON.parse(JSON.stringify(this.new_place))
      newPlace.pickup_location_id = null

      const route =
          this.newKanguroLocation && this.account.kanguro_account_uuid
            ? 'kanguro/add_address'
            : 'location/create'

      this[route]({
        account_id: self.$route.params.account_id,
        ...newPlace,
        kanguro_origin_uuid: this.newKanguroLocation
          ? this.account.kanguro_account_uuid || null
          : null,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Ubicación creada')
            self.getLocations()
            self.location_modal = false
            if (this.newKanguroLocation) {
              this.kanguro_pickup_location_created =
                  res.resource.pickup_location_id
              EventBus.$emit(
                'newKanguroLocation',
                res.resource.pickup_location_id
              )
            }
          }
        }
      })
    },
    async deleteLocation(pickupLocationId) {
      const self = this
      try {
        const response = await this.$bvModal.msgBoxConfirm(
          '¿Deseas continuar? No se puede deshacer.',
          {
            title: 'Eliminar ubicación',
            okVariant: 'danger',
            okTitle: 'Eliminar',
            cancelTitle: 'Cancelar'
          }
        )

        if (response) {
          this['location/destroy']({
            pickup_location_id: pickupLocationId,
            callback: (res) => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                self.getLocations()
                self.edit_location_modal = false
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    updateLocation(modal) {
      modal.preventDefault()
      const { name, disponibility_description: disponibilityDescription } =
          this.place
      const missingData = ![name, disponibilityDescription].every(Boolean)
      if (missingData) {
        this.place.validated = true
        return
      }
      const { place, polygons } = this
      const { polygons: polygonsOld, ...restPlace } = place
      this['location/update']({
        ...restPlace,
        callback: async (res) => {
          if (res.error) this.$message.error(res.error)
          const polygonsPromises = polygons.map((polygon) => {
            return new Promise((resolve, reject) => {
              this['location/createPolygon']({
                account_id: this.$route.params.account_id,
                polygon,
                pickup_location_id: this.place.pickup_location_id,
                callback: (res) => {
                  if (res.error) {
                    this.$message.error(res.error)
                    return reject(new Error(res.error))
                  }
                  this.$message.success('Polígono creado')
                  resolve(res)
                }
              })
            })
          })
          await Promise.all(polygonsPromises)
          this.$message.success('Punto actualizado')
          this.getLocations()
        }
      })
    },
    // GET DELIVERY TYPES. DELIVERY_ENABLED, PICKUP_ENABLED
    getEcommerceData() {
      const self = this

      this['delivery/ecommerce']({
        account_id: self.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.delivery_enabled = res.resource.delivery_enabled
            self.pickup_enabled = res.resource.pickup_enabled

            if (res.resource.Delivery_Basic) {
              self.delivery_price = res.resource.Delivery_Basic.delivery_price
              self.delivery_enabled = res.resource.delivery_enabled
            }
          }
        }
      })
    },
    // UPDATE DELIVERY TYPES. DELIVERY_ENABLED, PICKUP_ENABLED
    updateEcommerceData(type, value, silent = false) {
      const self = this
      const jsonData = {}

      if (type === 'delivery') {
        jsonData.delivery_enabled = value
        this.shippingCollapse = value
      } else if (type === 'pickup') {
        jsonData.pickup_enabled = value
        this.pickupCollapse = value
      }

      this['delivery/updateEcommerce']({
        account_id: self.$route.params.account_id,
        ...jsonData,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
            if (type === 'delivery') {
              self.delivery_enabled = !value
            } else if (type === 'pickup') {
              self.pickup_enabled = !value
            }
          } else {
            if (!silent) {
              self.$message.success('Cuenta actualizada')
            }
          }
        }
      })
    },
    associateEcommerce() {
      const self = this
      const jsonData = {
        account_id: self.$route.params.account_id,
        delivery_type_id: this.delivery_type_id || 1
      }

      this['delivery/associateEcommerce']({
        ...jsonData,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    // UPDATE BASIC DELIVERY TYPE PRICE (THERE WILL BE MORE TYPES)
    updateDeliveryBasic() {
      const self = this
      self.delivery_price =
          self.delivery_price < 0 || self.delivery_price === ''
            ? 0
            : self.delivery_price
      const jsonData = {
        delivery_price: self.delivery_price,
        account_id: self.$route.params.account_id
      }

      this['delivery/updateDeliveryBasic']({
        ...jsonData,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Cuenta actualizada')
            self.price_edited = false
          }
        }
      })
    },
    parseAvailability(place) {
      const text = place.disponibility_description

      try {
        if (text) {
          const times = text.match(/(\d{2}:\d{2} (am|pm))/gim)

          if (times[0]) {
            const hm = times[0].split(' ')[0].split(':')
            const hours = hm[0]
            const minutes = hm[1]
            const meridian = times[0].split(' ')[1]

            this.time_from = {
              hh: hours,
              mm: minutes,
              A: meridian
            }
          }

          if (times[1]) {
            const hm = times[1].split(' ')[0].split(':')
            const hours = hm[0]
            const minutes = hm[1]
            const meridian = times[1].split(' ')[1]

            this.time_to = {
              hh: hours,
              mm: minutes,
              A: meridian
            }
          }
        }
      } catch (e) {}

      try {
        if (text) {
          const days = text.match(
            /(Todos los días)|(Lunes a Viernes)|Lunes|Martes|Miércoles|Jueves|Viernes|Sábado|Domingo/gim
          )
          if (days.length === 1) {
            if (days[0] === 'Lunes a Viernes') {
              this.availability_days_picked = this.weekDays.slice()
            } else if (days[0] === 'Todos los días') {
              this.availability_days_picked = this.availability_days.map(
                (d) => d.text
              )
            }
          } else {
            for (const day of days) {
              this.availability_days_picked.push(day)
            }
          }
        }
      } catch (e) {}
    },
    openPlaceModal(place) {
      if (place) {
        this.place = Object.assign(this.place, place)
        this.parseAvailability(place)
      }

      this.$nextTick(() => {
        this.edit_location_modal = true
      })
    },
    createMap(lat, lng) {
      if (!this.map) {
        // eslint-disable-next-line no-undef
        this.map = new google.maps.Map(document.getElementById('pikcupMap'), {
          center: { lat, lng },
          zoom: 18,
          disableDefaultUI: true,
          gestureHandling: 'cooperative',
          zoomControl: true
        })

        this.map.addListener('center_changed', (event) => {
          this.new_place.latitude = this.map.getCenter().lat()
          this.new_place.longitude = this.map.getCenter().lng()
          this.drawCenterMarker(this.map.getCenter())
        })

        this.map.addListener('idle', (event) => {
          this.showDragMapAlert = true
          this.drawCenterMarker(this.map.getCenter())
        })
      } else {
        this.map.setCenter({ lat, lng })
      }
    },
    drawCenterMarker(center) {
      clearTimeout(this.drawMarkerTimeout)
      if (this.marker) {
        this.marker.setPosition(center)
        this.marker.setMap(this.map)
      } else {
        // eslint-disable-next-line no-undef
        this.marker = new google.maps.Marker({
          position: center,
          map: this.map
        })
      }
    },
    deleteMarker() {
      if (this.marker) {
        this.marker.setMap(null)
      }
    },
    initGoogleMapsAPI() {
      if (document.getElementById('gmaps-shipping')) {
        this.placesLoaded()
      } else {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.id = 'gmaps-shipping'
        script['data-name'] = 'maps-api'
        script.src =
            'https://maps.googleapis.com/maps/api/js?key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo&libraries=places,drawing&callback=initPlaces&language=es'
        document.getElementsByTagName('head')[0].appendChild(script)

        EventBus.$on('places_loaded', () => {
          this.placesLoaded()
        })
      }
    },
    placesLoaded() {
      // eslint-disable-next-line no-undef
      const autocomplete = new google.maps.places.Autocomplete(
        document.getElementById('search_autocomplete'),
        { types: ['geocode', 'establishment'] }
      )

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace()
        const { address_components: addressComponents = [] } = place
        this.new_place.country = addressComponents.find((c) =>
          c.types.includes('country')
        ).short_name
        for (let i = 0; i < place.address_components.length; i++) {
          const addressType = place.address_components[i].types[0]
          switch (addressType) {
            case 'street_number':
              this.new_place.street_number =
                  place.address_components[i][this.place_fields[addressType]]
              break
            case 'route':
              this.new_place.street =
                  place.address_components[i][this.place_fields[addressType]]
              break
            case 'sublocality_level_1':
              this.new_place.colony =
                  place.address_components[i][this.place_fields[addressType]]
              break
            case 'locality':
              this.new_place.city =
                  place.address_components[i][this.place_fields[addressType]]
              break
            case 'administrative_area_level_1':
              this.new_place.state =
                  place.address_components[i][this.place_fields[addressType]]
              break
            case 'postal_code':
              this.new_place.zip =
                  place.address_components[i][this.place_fields[addressType]]
              break
          }
        }

        this.new_place.full_address = place.formatted_address
        this.new_place.pickup_location_id = place.place_id
        this.new_place.map_image = place.url
        this.new_place.latitude = place.geometry.location.lat()
        this.new_place.longitude = place.geometry.location.lng()

        this.getMunicipality()
        this.createMap(this.new_place.latitude, this.new_place.longitude)
      })
    },
    resetCreateLocation() {
      this.new_place = Object.assign({}, this.new_place_copy)
      this.location_modal = false
      this.address_search = null
    },
    randomColor() {
      return '#' + Math.floor(Math.random() * 16777215).toString(16)
    },
    polygonColor() {
      const color = this.randomColor()

      if (this.colors.includes(color)) return this.polygonColor()

      this.colors.push(color)

      return color
    },
    removePolygon(id) {
      const polygon = this.place.polygons.find((p) => p.id === id)
      if (!polygon) return
      this.mapPolygons[polygon.id].setMap(null)
      this.place.polygons = this.place.polygons.filter((p) => p.id !== id)
      this['location/deletePolygon']({
        geometryId: polygon.id,
        callback: (res) => {
          if (res.error) return this.$message.error('Error al eliminar el polígono')
          this.$message.success('Polígono eliminado')
        }
      })
    },
    toggleEnable({ pickup_location_id: pickupLocationId }, key, value) {
      const data = { pickup_location_id: pickupLocationId }
      data[key] = value
      this['location/update']({
        ...data,
        callback: async (res) => {
          if (res.error) return this.$message.error(res.error)
          this.$message.success('Punto actualizado')
          const locations = [...this.locations]
          const locationIndex = locations.findIndex(
            (l) => l.pickup_location_id === pickupLocationId
          )
          const location = this.locations[locationIndex]
          location[key] = value
          locations.splice(locationIndex, 1, location)
          this.matchFilters(locations)
        }
      })
    },
    async initPickup(location) {
      const sameLocation =  this.place.pickup_location_id === location.pickup_location_id

      if (this.place && sameLocation) { return }

      this.mapPolygons = {}
      this.selected_products = []
      this.place = location

      const latLng = new google.maps.LatLng(
        this.place.latitude,
        this.place.longitude
      )

      this.polygons = []
      const { polygons: currentPolygons = [] } = this.place
      this.colors = currentPolygons.map((polygon) => polygon.color)

      const mapOpt = {
        center: latLng,
        zoom: 15,
        disableDefaultUI: true,
        gestureHandling: 'cooperative',
        zoomControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }

      this.pickupMap = new google.maps.Map(document.getElementById('map-container'), mapOpt)
      // eslint-disable-next-line no-new
      new google.maps.Marker({
        position: latLng,
        map: this.pickupMap,
        title: this.place.full_address
      })

      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ['polygon']
        }
      })

      this.drawingManager.setMap(this.pickupMap)

      const mapPolygons = currentPolygons.map(polygon=>{
        const polygonObject = polygon.draw({
          google,
          color: polygon.color
        })
        const drawPolygon = new google.maps.Polygon(polygonObject)
        drawPolygon.setMap(this.pickupMap)

        return { drawPolygon, polygon }
      })

      this.getLocationSchedule(this.place.pickup_location_id)
      console.log("AFTER", this.place)

      this.$nextTick(()=>{
        mapPolygons.forEach(({polygon,drawPolygon}) => {
          this.mapPolygons = {
            ...this.mapPolygons,
            [polygon.id]: drawPolygon
          }
        })
      })
      this.$nextTick(() => this.drawPolygonsFinished())
      this.$nextTick(() => this.loadProducts())
    },
    drawPolygonsFinished() {
      this.drawingManager.addListener('overlaycomplete', (event) => {
        event.overlay.visible = false

        const coordinates = event.overlay.getPath().getArray()
        const polygonPoints = coordinates.map((coordinate) => {
          return [coordinate.lat(), coordinate.lng()]
        })
        const polygon = new Polygon(polygonPoints)

        this.polygons.push(polygon)
        this.place.polygons.push(polygon)

        this.$nextTick(()=>{
         let polygonObject = polygon.draw({
          google,
          color: this.polygonColor()
         })
        const mapObject = new google.maps.Polygon(polygonObject)

        mapObject.setMap(this.pickupMap) // draw polygon on map
        this.mapPolygons[polygon.id] = mapObject
        })
      })
    },
    changePage(page) {
      if (page <= 0 || page > this.total_pages) return
      this.loadProducts()
    },
    searchProducts() {
      this.current_page = 1
      this.loadProducts()
    },
    loadProducts() {
      const params = {
        pickup_location_id: Number(this.place.pickup_location_id),
        limit: 20,
        page: this.current_page
      }
      if (this.product_search) {
        params.name = this.product_search
      }
      this['location/products']({
        account_id: this.$route.params.account_id,
        params,
        callback: (response) => {
          if (response.error) return this.$message.error(response.error)
          const {
            resource = [],
            page = 1,
            total_pages: totalPages = 1
          } = response
          this.place_products = resource.map((p) => new Product(p))
          this.total_pages = Number(totalPages)
          this.current_page = Number(page)
        }
      })
    },
    toggleProduct(id) {
      const product = this.place_products.find((product) => product.id === id)

      if (!product) return

      const { enabled, stockId } = product

      this['location/toggleProduct']({
        stockId: Number(stockId),
        enabled,
        callback: (response) => {
          if (response.error) return this.$message.error(response.error)

          this.$message.success('Producto actualizado')
        }
      })
    }
  },
  watch: {
    allLocations(val) {
      if (!val) return this.matchFilters(this.locations)
      this.filters = Object.keys(this.filters).reduce((acc, key) => {
        acc[key] = false
        return acc
      }, {})
      this.locationsList = [...this.locations]
    },
    search_input() {
      this.matchFilters(this.locations)
    },
    filters: {
      deep: true,
      handler() {
        this.matchFilters(this.locations)
      }
    },
    locations() {
      this.matchFilters(this.locations)
      this.buildBranchOfficesToDerivate()
    },
    locationsList() {
      const { selected_locations: selectedLocations } = this
      this.locationsList.forEach((location) => {
        const { pickup_location_id: pickupLocationId } = location

        const locationIndex = selectedLocations.findIndex((locationSelected) =>  {
             locationSelected.pickup_location_id === pickupLocationId
        })

        if (locationIndex > -1) return location.checked = true

        location.checked = false
      })
    },
  },
  mounted() {
    this.new_place_copy = Object.assign({}, this.new_place)
    this.getLocations()
    this.getEcommerceData()
    this.initGoogleMapsAPI()
    EventBus.$on('changeDeliveryTypeCanceled', () => {
      this.kanguro_enabled_temp = this.isKanguroEnabled
    })
  },
  beforeUnmount() {
    EventBus.$off('places_loaded')
    EventBus.$off('places_loaded')
    EventBus.$off('changeDeliveryTypeCanceled')
    const nodeList = document.querySelectorAll(
      "script[src^='https://maps.googleapis.com']"
    )
    for (let i = 0; i < nodeList.length; i++) {
      nodeList[i].remove()
    }
  },
  components: {
    Kanguro: () => import('@/views/account/Kanguro.vue'),
    'k-select': Select
  }
}
</script>

  <style lang="scss" scoped>
  .location-row {
    border: 1px solid rgba(0, 0, 0, 0.1);
    &:hover {
      background-color: rgba(0, 0, 0, 0.03);
      cursor: pointer;
    }
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  .chevron-button {
    transition: 0.5s;

    &.collapsed {
      transform: rotate(180deg);
    }
  }
  .locations {
    position: relative;
    float: left;
    overflow: hidden;
    z-index: 1;
  }
  .location-dropdown {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10001;
    background-color: rgba(0, 0, 0, 0.5);
  }
  </style>

  <style>
  .pac-container {
    z-index: 1000000000;
  }

  .vue__time-picker .dropdown {
    top: auto !important;
    bottom: calc(100% + 2px) !important;
  }

  .product-card {
    height: clamp(150px, 200px);
    box-sizing: border-box;
    background-color: #fffefe;
  }

  .cardToSlice{
    border-color: #d8dde2;
  }
  </style>
